import React, { Component } from 'react';

class SuccessfulBooking extends Component {
    render() { 
        return ( 
            <React.Fragment>
                <h4>
                    Билеты забронированы
                </h4>
                <div>
                    Далее вы будете автоматически 
                    перенаправлены 
                    на платежную страницу банка.
                    Оплата возможна в течение 8 минут 
                    с момента бронирования. 
                </div>
            </React.Fragment>
         );
    }
}
 
export default SuccessfulBooking;